import { useEffect, useState } from "react"
import api from "../../utils/api"

// Companies asking the signed-in person to allow automatic payment from their
// UT wallet. Shown in the dashboard bell until the person turns them on or off.
export function useAutopayApprovalRequests(enabled = true) {
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setRequests([])
      return undefined
    }
    let active = true
    setLoading(true)
    api
      .get("/ut-bills/autopay-approvals/requests")
      .then((response) => {
        if (active) setRequests(Array.isArray(response?.data?.requests) ? response.data.requests : [])
      })
      .catch(() => {
        // A missing notification must never break the dashboard.
        if (active) setRequests([])
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [enabled])

  return { requests, loading }
}
